export const hasError = state => state.feedback.hasError
export const isPending = state => state.feedback.isPending
export const user = state => state.auth.user
